import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { blue } from '@material-ui/core/colors/';
import './ExpirationLicenseTable.css'
import api_data from '../../../data/TableData'
import Paper from '@mui/material/Paper';


const products = api_data['ExpiratedLicense']


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: blue[800],
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

export default function SecondaryCustomizedTablesAdmin() {

  return (
   
        <div className="CollapsiTableContainer">
          <TableContainer component={Paper} style={{ maxHeight: '100%' }}>
            <Table >
              <TableHead>
                <TableRow>
                  <StyledTableCell align="right">Empresa</StyledTableCell>
                  <StyledTableCell align="right">Tipo de licença</StyledTableCell>
                  <StyledTableCell align="right">Licença</StyledTableCell>
                  <StyledTableCell align="right">Criado</StyledTableCell>
                  <StyledTableCell align="right">Expira</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {products.map((row) => (
                  <StyledTableRow key={row.name}>
                    <StyledTableCell align="right">{row.name}</StyledTableCell>
                    <StyledTableCell align="right">{row.type}</StyledTableCell>
                    <StyledTableCell align="right">{row.license}</StyledTableCell>
                    <StyledTableCell align="right">{row.createdAt}</StyledTableCell>
                    <StyledTableCell align="right">{row.expirate}</StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>

  );
}